import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { UserProvider } from "./context/userContext";

const root = ReactDOM.createRoot(document.getElementById("arcaptor"));
root.render(
  <UserProvider>
    <App />
  </UserProvider>
);
